<template>
  <div
    class="bg-white border-t-4 border-blue-800 inline-block mx-auto text-xl pt-4 pb-4 cursor-default"
  >
    <div class="px-6 py-3 flex flex-col items-center relative">
      <slot></slot>
    </div>
  </div>
</template>
